import {
  moreBooking,
  itiraStates,
  alreadyTravelingState,
  chooseInitialDatesState,
  flexibleTravelingState,
  regionalTravel,
  regionalTravelValidation,
  alreadyTravelValidation,
  chooseDatesTravelValidation,
  TripCostPaymentDatesValidation,
  TripCostPaymentDatesState,

  //checkout states
  checkoutTravelersState,
  beneficiaryState,
  emergencyContactState,
  paymentCardState,
  billingState,
  travelerCheckoutBillingValidation,
  travelerCheckoutPaymentCardValidation,
  beneficiaryNewValidation,
  emergencyContactNewValidation,
  travelerCheckoutValidation,
  setMultiDestination,
} from "@/composable/vuelidate";
import { router } from "@/router/index";

let emptyAllItiraState = () => {
  itiraStates.value = [];

  regionalTravel.region = {
    country: null,
    country_iso: null,
    state_iso: null,
    state: null,
    city: null,
    street: null,
    formatted_address: null,
  };
  regionalTravel.destination = {
    country: null,
    country_iso: null,
    state_iso: null,
    state: null,
    city: null,
    street: null,
    formatted_address: null,
  };

  // Object.keys(regionalTravel).map((key) => {
  //   regionalTravel[key] = null;
  // });

  regionalTravelValidation.value.$reset();
  Object.keys(alreadyTravelingState.value).map((key) => {
    alreadyTravelingState.value[key] = null;
  });
  alreadyTravelValidation.value.$reset();
  Object.keys(chooseInitialDatesState.value).map((key) => {
    chooseInitialDatesState.value[key] = null;
  });
  chooseDatesTravelValidation.value.$reset();
  Object.keys(flexibleTravelingState.value).map((key) => {
    flexibleTravelingState.value[key] = null;
  });
  flexibleTravelingState.value.months = [];

  flexibleTravelingState.flexible_date_type = "week";
  moreBooking.value = false;

  Object.keys(TripCostPaymentDatesState).map((key) => {
    TripCostPaymentDatesState[key] = null;
  });
  TripCostPaymentDatesValidation.value.$reset();

  setMultiDestination([]);
};
export const allClearItira = () => {
  emptyAllItiraState();
  router.push({
    path: "/itira/travel-reasons",
  });
};
export const allClearItiraWithoutRedirect = () => {
  emptyAllItiraState();
};

export let emprtyAllCheckoutStatesVulidate = () => {
  checkoutTravelersState.value = [];

  travelerCheckoutValidation.value.$reset();

  Object.keys(beneficiaryState.value).map((key) => {
    beneficiaryState.value[key] = null;
  });

  beneficiaryNewValidation.value.$reset();

  Object.keys(emergencyContactState.value).map((key) => {
    emergencyContactState.value[key] = null;
  });

  emergencyContactNewValidation.value.$reset();

  Object.keys(paymentCardState.value).map((key) => {
    paymentCardState.value[key] = null;
  });
  travelerCheckoutPaymentCardValidation.value.$reset();

  Object.keys(billingState.value).map((key) => {
    billingState.value[key] = null;
  });
  travelerCheckoutBillingValidation.value.$reset();
};
